import React from "react";
import { t } from "i18next";
import {
  Box,
  Card,
  Flex,
  HStack,
  Image,
  Spacer,
  Stack,
  Text,
} from "@chakra-ui/react";
import { CrashType, riskFactorColors, Score } from "@keita/lanepatrol-sdk";
import {
  tRiskFactor,
  tScoreType,
  scoreCrashTypesIcons,
} from "../utils/score-utils";

const entryMaxWidth = 150;
const defaultColor = "#DDDDDD";

export const ViewScore = ({ score }: { score: Score | undefined | null }) => {
  return (
    <Flex direction="column" fontSize="sm">
      <Flex justifyContent="center" gap={5}>
        {Object.values(CrashType).map((scoreKey, index) => {
          return (
            <Flex
              direction="column"
              maxWidth={36}
              key={index}
              justifyContent={"space-between"}
            >
              <Image
                alignSelf={"center"}
                maxWidth={120}
                src={scoreCrashTypesIcons[scoreKey]}
              />
              <Text textAlign="center" mt={3} mb={3}>
                {tScoreType(scoreKey)}
              </Text>
              <Box
                textAlign={"center"}
                py={2}
                borderRadius={"5px"}
                fontSize="md"
                bg={
                  score
                    ? riskFactorColors[score[scoreKey].riskFactor]
                    : defaultColor
                }
              >
                {score ? score[scoreKey].value.toFixed(2) : "-"}
              </Box>
            </Flex>
          );
        })}
      </Flex>
      <HStack mt={8} justifyContent={"center"}>
        <Spacer />
        <Card.Root overflow={"hidden"} maxWidth={entryMaxWidth}>
          <Stack>
            <Text
              textAlign="center"
              bgColor={"#133548"}
              color="white"
              fontWeight={600}
              px={3}
              py={2}
            >
              {t("coding:global")}
            </Text>
            <Box textAlign="center" fontSize="md">
              {score ? score.global.value.toFixed(2) : "-"}
            </Box>
            <Box
              textAlign={"center"}
              py={2}
              bg={
                score ? riskFactorColors[score.global.riskFactor] : defaultColor
              }
            >
              {score ? tRiskFactor(score.global.riskFactor) : "-"}
            </Box>
          </Stack>
        </Card.Root>

        <Spacer />
      </HStack>
    </Flex>
  );
};
